export default __webpack_public_path__ + "static/media/exclusive.b198c905.mp4";